<template>
  <div id="app">
    <app-header />
    <transition name="page">
      <router-view />
    </transition>
    <app-footer />
    <vue-progress-bar />
  </div>
</template>

<script>
import AppHeader from '@/components/Header'
import AppFooter from '@/components/Footer'

export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: 'OPS-Placard';
  src: url('~/fonts/opsplacard-regular-1.otf') format('opentype');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'MaisonNeue';
  src: url('~/fonts/MaisonNeue-Medium.woff') format('woff'),
    url('~/fonts/MaisonNeue-Medium.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family:$ops-placard;
  min-height:100%;
  display:flex;
  flex-wrap:wrap;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;

  .page {
    &-enter {
      opacity:0;
      &-active {
        transition:opacity 300ms ease-in-out 100ms;
      }
      &-to {
        opacity:1;
      }
    }
  }
}
</style>
